<template>
  <div class="propertyDetails_pcarousel-container">
    <div class="carousel">
      <transition-group
        :name="transitionName"
        mode="in-out"
        tag="div"
        class="carousel-inner"
        @mouseenter="pauseAutoPlay"
        @mouseleave="resumeAutoPlay"
      >
        <div
          v-for="(slide, index) in slides"
          :key="slide.id"
          class="carousel-item"
          :class="{ active: currentIndex === index }"
          v-show="currentIndex === index"
        >
          <img
            v-if="slide.bannerType"
            @touchstart.prevent="handleTouchStart"
            @touchend.prevent="handleTouchEnd"
            @touchcancel.prevent="handleTouchEnd"
            :src="slide.bannerImg"
            alt=""
          />

          <video
            playsinline
            autoplay
            loop
            muted
            v-if="!slide.bannerType"
            @touchstart.prevent="handleTouchStart"
            @touchend.prevent="handleTouchEnd"
            @touchcancel.prevent="handleTouchEnd"
            :src="slide.bannerImg"
            type="video/mp4"
          ></video>
          <div class="carousel-caption" v-if="slide.caption">
            <h3>{{ slide.caption.title }}</h3>
            <p>{{ slide.caption.description }}</p>
          </div>
        </div>
      </transition-group>
      <div class="lab">{{ currentIndex + 1 }}/{{ slides.length }}</div>
      <!-- 导航箭头 -->
      <button
        class="carousel-control prev"
        @click="prevSlide"
        v-show="showControls"
      >
        &lsaquo;
      </button>
      <button
        class="carousel-control next"
        @click="nextSlide"
        v-show="showControls"
      >
        &rsaquo;
      </button>
    </div>

    <!-- 指示器 -->
    <div class="carousel-indicators" v-if="indicators">
      <span
        v-for="(slide, index) in slides"
        :key="'indicator-' + slide.id"
        class="indicator"
        :class="{ active: currentIndex === index }"
        @click="goToSlide(index)"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  // 轮播图组件
  props: {
    slides: {
      type: Array,
      required: true,
      default: () => [
        {
          id: 1,
          bannerImg: "",
          // 显示的是否是图片
          bannerType: true,
          caption: {
            title: "标题1",
            description: "描述内容1",
          },
        },
      ],
    },
    //   指示器是否显示
    indicators: {
      type: Boolean,
      default: false,
    },
    interval: {
      type: Number,
      default: 5000,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    showControls: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentIndex: 0,
      isPlaying: false,
      timer: null,
      transitionName: "slide-left",
      isPlaying: false,
      isSwiping: false, // 新增标志位
    };
  },
  mounted() {
    if (this.autoplay) {
      this.startAutoPlay();
    }
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
  methods: {
    toggleVideo() {
      const video = this.$refs.videoPlayer;
      if (video.paused) {
        video.play();
        this.isPlaying = true;
      } else {
        video.pause();
        this.isPlaying = false;
      }
    },
    handleTouchStart(e) {
      if (e.target.classList.contains("video-control")) return;
      this.isSwiping = true;
      this.pauseAutoPlay(); // 暂停自动轮播
      this.touchStartX = e.changedTouches[0].screenX;
      this.touchStartTime = Date.now(); // 记录触摸开始时间
    },
    handleTouchEnd(e) {
      if (!this.touchStartX) return; // 避免无效触发
      this.touchEndX = e.changedTouches[0].screenX;
      this.touchEndTime = Date.now(); // 记录触摸结束时间

      this.handleSwipe();
      this.clearTouchData(); // 清除记录
      // 滑动结束后延迟恢复自动轮播（避免立即触发）
      setTimeout(() => {
        this.isSwiping = false;
        if (this.autoplay) this.resumeAutoPlay();
      }, 1000); // 延迟 1 秒恢复
    },
    clearTouchData() {
      this.touchStartX = null;
      this.touchEndX = null;
    },
    handleSwipe() {
      const diff = this.touchEndX - this.touchStartX;
      const timeDiff = this.touchEndTime - this.touchStartTime;
      const swipeThreshold = window.innerWidth * 0.1; // 滑动阈值
      const maxSwipeTime = 300; // 最大允许滑动时间（毫秒）

      // 只有快速滑动且距离足够时才触发
      if (timeDiff < maxSwipeTime && Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          this.prevSlide(); // 向右滑
        } else {
          this.nextSlide(); // 向左滑
        }
      }
    },
    startAutoPlay() {
      this.stopAutoPlay();
      if (this.isSwiping) return;
      this.isPlaying = true;
      this.timer = setInterval(() => {
        if (!this.isSwiping) this.nextSlide();
      }, this.interval);
    },
    stopAutoPlay() {
      this.isPlaying = false;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    pauseAutoPlay() {
      if (this.isPlaying) {
        this.stopAutoPlay();
      }
    },
    resumeAutoPlay() {
      if (!this.isPlaying && this.autoplay) {
        this.startAutoPlay();
      }
    },
    nextSlide() {
      this.transitionName = "slide-right";
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    },
    prevSlide() {
      this.transitionName = "slide-left";
      this.currentIndex =
        (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    },
    goToSlide(index) {
      this.currentIndex = index;
      if (this.autoplay) {
        this.startAutoPlay();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.carousel-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  will-change: transform; /* 提前告知浏览器准备 GPU 加速 */
  height: 100%;
  transition: translate 0.5s ease;
}
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.5s ease;
}

.slide-left-enter {
  transform: translateX(-100%);
}

.slide-left-leave-to {
  transform: translateX(100%);
}

.slide-right-enter {
  transform: translateX(100%);
}

.slide-right-leave-to {
  transform: translateX(-100%);
}
/* 响应式设计 */
@media (max-width: 768px) {
  .carousel {
    padding-bottom: 75%; /* 4:3 宽高比 */
  }

  .carousel-caption {
    bottom: 10px;
    padding: 10px;
  }

  .carousel-caption h3 {
    font-size: 1.2rem;
    margin-bottom: 5px;
  }

  .carousel-caption p {
    font-size: 0.9rem;
  }

  .carousel-control {
    width: 30px;
    height: 30px;
    font-size: 16px;
  }
}
</style>